import * as React from "react";

import { cn } from "@/lib/utils";

// Figma "Tab Item" (ver.6): Active = 500 + 2px #FD5108 underline, Default = 400.
export interface NvTabItemProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
}

const NvTabItem = React.forwardRef<HTMLButtonElement, NvTabItemProps>(
  ({ className, active = false, type = "button", ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      role="tab"
      aria-selected={active}
      className={cn(
        "whitespace-nowrap px-1 py-[14px] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-nv-brand",
        active
          ? "border-b-2 border-nv-brand text-nv-button-md text-nv-text-primary"
          : "text-nv-body-lg text-nv-text-primary hover:text-nv-text-strong",
        className,
      )}
      {...props}
    />
  ),
);
NvTabItem.displayName = "NvTabItem";

export { NvTabItem };
